import { takeLatest, put, takeLeading } from 'redux-saga/effects';
import {
    ACT_AUTH_TOKEN_SUCCESS,
    ACT_EMP_ADD_INIT,
    ACT_EMP_FETCH_INIT,
    ACT_EMP_UPDATE_INIT,
} from "../constants/actions";
import Api from "../services/ApiService";
import {
    fetchEmployeesInitAction,
    fetchEmployeesSuccessAction,
    addEmployeeSuccessAction,
    editEmployeeSuccessAction,
} from "../actions/employeesActions";


function* addEmployee(action) {
    const { status, data } = yield Api.post('users', action.employeeToAdd);
    if (status === 201) {
        yield put(addEmployeeSuccessAction(data))
    } else {
        console.log("Add employee is not a 201", status);
    }
    yield put(fetchEmployeesInitAction());
}

function* editEmployee(action) {
  const { status, data } = yield Api.patch(`users/${action.id}`, action.employeeData);
  if (status === 201) {
    yield put(editEmployeeSuccessAction(data.data));
  } else {
    console.log("Edit employee is not a 201", status);
  }
}

function* fetchEmployees() {
    const {status, data} = yield Api.get('users');
    if(status === 200) {
        yield put(fetchEmployeesSuccessAction(data));
    } else {
        console.log("List employees is not a 200", status);
    }
}

export default function* employeesSagas (){
    yield takeLeading(ACT_EMP_FETCH_INIT, fetchEmployees);
    yield takeLeading(ACT_EMP_ADD_INIT, addEmployee);
    yield takeLeading(ACT_EMP_UPDATE_INIT, editEmployee);
    yield takeLatest(ACT_AUTH_TOKEN_SUCCESS, fetchEmployees);
}

